import { render, staticRenderFns } from "./product.vue?vue&type=template&id=25dc180a&"
import script from "./product.vue?vue&type=script&lang=js&"
export * from "./product.vue?vue&type=script&lang=js&"
import style0 from "./product.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25dc180a')) {
      api.createRecord('25dc180a', component.options)
    } else {
      api.reload('25dc180a', component.options)
    }
    module.hot.accept("./product.vue?vue&type=template&id=25dc180a&", function () {
      api.rerender('25dc180a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/pages/product.vue"
export default component.exports